/**
 * Detect browser language: Chinese (zh*) -> zh, otherwise en.
 * Checks all entries in navigator.languages, then navigator.language / userLanguage.
 * If any preferred language is Chinese, show Chinese UI.
 */
export function getLocale() {
  if (typeof navigator === 'undefined') return 'en';
  const list = [
    ...(Array.isArray(navigator.languages) ? navigator.languages : []),
    navigator.language,
    navigator.userLanguage
  ].filter(Boolean);
  for (const raw of list) {
    const lang = String(raw).toLowerCase().split(/[-_]/)[0];
    if (lang === 'zh') return 'zh';
  }
  return 'en';
}

export function isZh() {
  return getLocale() === 'zh';
}
